/**
 * External dependencies
 */
import cx from 'classnames';

const Reveal = ({ className, children, show = false }) => {
    return (
        <div
            className={cx('reveal', {
                show,
            })}
        >
            <div className={cx('reveal__inner', className)}>{children}</div>
        </div>
    );
};

export default Reveal;
